export default __webpack_public_path__ + "static/media/others-category-icon.2ff87575.svg";